import { IAction, isType } from '@zaibot/fsa';

import { IAdmin } from '../types';
import ADMIN_CREATE from './actions/ADMIN_CREATE';
import ADMIN_UPDATE from './actions/ADMIN_UPDATE';
import ADMIN_INIT from './actions/ADMIN_INIT';
import DEADLINE_QUESTIONS from './actions/DEADLINE_QUESTIONS';

interface IState {
  item: IAdmin;
}
export const emptyState: IState = {
  item: { documentId: '', deadlineanswer: 0, factionvisible:false, modquestion:false} as IAdmin,
};

export const selector = (state: any) => state.beheer as IState;

export const reducer = (state = emptyState, action: IAction) => {
  if (isType(action, ADMIN_INIT)) {
    return { ...state, item: action.payload.item, busy: action.payload.busy, sendingenabled: false, answerenabled:false };
  }    
  if (isType(action, ADMIN_CREATE)) {
    return { ...state, item: action.payload.item, busy: action.payload.busy };
  }   
  if (isType(action, ADMIN_UPDATE)) {
    return { ...state, item: action.payload.item, busy: action.payload.busy };
  }  
  if (isType(action, DEADLINE_QUESTIONS)) {
    return {...state, sendingenabled: action.payload.sendingenabled, answerenabled: action.payload.answerenabled};
  }
  return state; 
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/admin/reducer.tsx